<template>
  <base-icon
      v-on="$listeners"
      v-bind="$attrs"
      :transform-function="(value) => typeof value === 'object' ? value.transferFileDownloaded : value"
      icon="mdi-credit-card-outline"
      :title="(value) => value ? 'settlement.titleIsTransferFileDownloaded' : 'settlement.titleIsNotTransferFileDownloaded'"
  />
</template>

<script>
import BaseIcon from '@/components/icons/BaseIcon';
export default {
  name: 'SettlementSepaDownloadedIcon',
  components: {BaseIcon},
}
</script>

<style scoped>

</style>